import { type Ref, ref, watch } from 'vue'
import { useLoadControlWidget } from './api'

const useModel = () => {
  const items = ref([
    { id: 1, relay: 0, contactor: 0, mode: 0, description: '' },
    { id: 2, relay: 0, contactor: 0, mode: 0, description: '' },
    { id: 3, relay: 0, contactor: 0, mode: 0, description: '' },
  ])

  const loadData = (cabinet_id: Ref<number>) => {
    const result = useLoadControlWidget(cabinet_id)

    watch(result.data, () => {
      if (result.data.value) {
        items.value = result.data.value.data.monitor_sensors
          .filter((item: any) => item.id <= result.data.value?.data.contactor_count)
          .sort((a: any, b: any) => a.id - b.id)
      }
    })

    return result
  }

  return {
    items,

    loadData,
  }
}

export default useModel
